
import React from 'react';

const QtyInput = ({ quantity, onQuantityChange }) => {
  const handleInputChange = (event) => {
    // Ensure only positive integers are accepted
    const value = event.target.value;
    if (value === '' || (/^[1-9]\d*$/.test(value) && parseInt(value, 10) > 0)) {
      onQuantityChange(value === '' ? '' : parseInt(value, 10));
    } else if (value === '0') {
        // Prevent entering 0 directly, but allow clearing the input
        onQuantityChange('');
    }
  };

  return (
    <div className="form-group">
      <label htmlFor="qty-input"><strong>Quantity</strong></label>
      <input
        type="number"
        id="qty-input"
        value={quantity}
        onChange={handleInputChange}
        min="1" // Set minimum value for browser validation
        placeholder="Number of labels"
        className="form-control"
      />
    </div>
  );
};

export default QtyInput;

